<app-navbar></app-navbar>

<!-- Hero Section -->
<section class="privacy-hero-section">
  <div class="container">
    <div class="hero-content">
      <h1>Politique de Confidentialité</h1>
      <p class="hero-subtitle">Protection de vos données personnelles</p>
      <p class="hero-update">Dernière mise à jour : {{ lastUpdateDate }}</p>
    </div>
  </div>
</section>

<!-- Table of Contents -->
<section class="toc-section">
  <div class="container">
    <div class="toc-wrapper">
      <h2>Sommaire</h2>
      <ul class="toc-list">
        <li><a (click)="scrollToSection('article-1')">1. Introduction</a></li>
        <li><a (click)="scrollToSection('article-2')">2. Responsable du traitement</a></li>
        <li><a (click)="scrollToSection('article-3')">3. Données collectées</a></li>
        <li><a (click)="scrollToSection('article-4')">4. Finalités du traitement</a></li>
        <li><a (click)="scrollToSection('article-5')">5. Base légale</a></li>
        <li><a (click)="scrollToSection('article-6')">6. Durée de conservation</a></li>
        <li><a (click)="scrollToSection('article-7')">7. Vos droits</a></li>
        <li><a (click)="scrollToSection('article-8')">8. Cookies</a></li>
        <li><a (click)="scrollToSection('article-9')">9. Sécurité des données</a></li>
        <li><a (click)="scrollToSection('article-10')">10. Partage des données</a></li>
        <li><a (click)="scrollToSection('article-11')">11. Transferts internationaux</a></li>
        <li><a (click)="scrollToSection('article-12')">12. Modifications</a></li>
      </ul>
    </div>
  </div>
</section>

<!-- Privacy Content -->
<section class="privacy-content-section">
  <div class="container">
    <div class="content-wrapper">
      
      <!-- Article 1 -->
      <article id="article-1" class="privacy-article">
        <div class="article-number">Article 1</div>
        <h2>Introduction</h2>
        <p>
          <strong>Digital Alchemy</strong> accorde une grande importance à la protection de vos données personnelles et au respect de votre vie privée. La présente Politique de Confidentialité a pour objectif de vous informer de manière claire et transparente sur la façon dont nous collectons, utilisons, stockons et protégeons vos données personnelles.
        </p>
        <p>
          Cette politique s'applique à tous les services proposés par Digital Alchemy, que ce soit via notre site web, nos communications par email, ou tout autre canal de communication.
        </p>
        <div class="highlight-box">
          <strong>🔒 Notre engagement :</strong> Nous nous engageons à respecter le Règlement Général sur la Protection des Données (RGPD) européen ainsi que la législation marocaine en matière de protection des données personnelles (Loi n° 09-08).
        </div>
        <p>
          En utilisant nos services, vous acceptez les pratiques décrites dans cette politique. Si vous n'acceptez pas ces conditions, nous vous invitons à ne pas utiliser nos services.
        </p>
      </article>

      <!-- Article 2 -->
      <article id="article-2" class="privacy-article">
        <div class="article-number">Article 2</div>
        <h2>Responsable du Traitement des Données</h2>
        <p>
          Le responsable du traitement de vos données personnelles est :
        </p>
        <div class="info-box">
          <h3>Digital Alchemy</h3>
          <p><strong>Forme juridique :</strong> Agence de Marketing Digital</p>
          <p><strong>Adresse :</strong> Bd Dammam, Technopark Casablanca , Maroc . Rabat, Maroc</p>
          <p><strong>Email :</strong> Digitalalchemyma&#64;gmail.com</p>
          <p><strong>Téléphone (Maroc) :</strong> +212 690 459 525</p>
          <p><strong>Téléphone (France) :</strong> +33 1 23 45 67 89</p>
        </div>
        <p>
          Pour toute question relative à la protection de vos données personnelles ou pour exercer vos droits, vous pouvez nous contacter aux coordonnées ci-dessus.
        </p>
      </article>

      <!-- Article 3 -->
      <article id="article-3" class="privacy-article">
        <div class="article-number">Article 3</div>
        <h2>Données Personnelles Collectées</h2>
        <p>
          Nous collectons différents types de données personnelles selon les services que vous utilisez et les interactions que vous avez avec nous.
        </p>
        
        <h3>3.1 Données que vous nous fournissez directement</h3>
        <ul>
          <li><strong>Identité :</strong> Nom, prénom</li>
          <li><strong>Contact :</strong> Adresse email, numéro de téléphone</li>
          <li><strong>Informations professionnelles :</strong> Nom de l'entreprise, fonction, nombre d'employés</li>
          <li><strong>Informations sur votre projet :</strong> Services souhaités, budget, détails du projet</li>
          <li><strong>Communications :</strong> Contenu de vos messages et échanges avec nous</li>
        </ul>
        
        <h3>3.2 Données collectées automatiquement</h3>
        <ul>
          <li><strong>Données de navigation :</strong> Adresse IP, type de navigateur, pages visitées</li>
          <li><strong>Données techniques :</strong> Type d'appareil, système d'exploitation, résolution d'écran</li>
          <li><strong>Données de localisation :</strong> Pays, ville (via l'adresse IP)</li>
          <li><strong>Cookies et technologies similaires :</strong> Identifiants de session, préférences utilisateur</li>
        </ul>
        
        <h3>3.3 Données que nous ne collectons PAS</h3>
        <div class="highlight-box success">
          <strong>✓ Respect de votre vie privée :</strong>
          <br>Nous ne collectons jamais de données sensibles telles que : origine raciale ou ethnique, opinions politiques, convictions religieuses, données de santé, orientation sexuelle, ou données biométriques.
        </div>
      </article>

      <!-- Article 4 -->
      <article id="article-4" class="privacy-article">
        <div class="article-number">Article 4</div>
        <h2>Finalités du Traitement des Données</h2>
        <p>
          Vos données personnelles sont collectées et traitées pour les finalités suivantes :
        </p>
        
        <div class="purpose-grid">
          <div class="purpose-card">
            <div class="purpose-icon">📧</div>
            <h4>Gestion des demandes</h4>
            <p>Traiter vos demandes de devis, de contact et de renseignements</p>
          </div>
          
          <div class="purpose-card">
            <div class="purpose-icon">🤝</div>
            <h4>Relation client</h4>
            <p>Gérer notre relation commerciale et assurer le suivi de vos projets</p>
          </div>
          
          <div class="purpose-card">
            <div class="purpose-icon">📊</div>
            <h4>Amélioration des services</h4>
            <p>Analyser l'utilisation de notre site pour améliorer nos services</p>
          </div>
          
          <div class="purpose-card">
            <div class="purpose-icon">📱</div>
            <h4>Communication marketing</h4>
            <p>Vous envoyer des informations sur nos services (avec votre consentement)</p>
          </div>
          
          <div class="purpose-card">
            <div class="purpose-icon">⚖️</div>
            <h4>Obligations légales</h4>
            <p>Respecter nos obligations légales et comptables</p>
          </div>
          
          <div class="purpose-card">
            <div class="purpose-icon">🔒</div>
            <h4>Sécurité</h4>
            <p>Assurer la sécurité de notre site et prévenir la fraude</p>
          </div>
        </div>
      </article>

      <!-- Article 5 -->
      <article id="article-5" class="privacy-article">
        <div class="article-number">Article 5</div>
        <h2>Base Légale du Traitement</h2>
        <p>
          Conformément au RGPD, nous traitons vos données personnelles sur les bases légales suivantes :
        </p>
        
        <ul>
          <li>
            <strong>Consentement :</strong> Pour l'envoi de communications marketing et l'utilisation de certains cookies non essentiels. Vous pouvez retirer votre consentement à tout moment.
          </li>
          <li>
            <strong>Exécution d'un contrat :</strong> Pour traiter vos demandes de devis et gérer nos relations commerciales.
          </li>
          <li>
            <strong>Intérêt légitime :</strong> Pour améliorer nos services, assurer la sécurité de notre site et analyser son utilisation.
          </li>
          <li>
            <strong>Obligation légale :</strong> Pour respecter nos obligations légales, notamment en matière de comptabilité et de fiscalité.
          </li>
        </ul>
      </article>

      <!-- Article 6 -->
      <article id="article-6" class="privacy-article">
        <div class="article-number">Article 6</div>
        <h2>Durée de Conservation des Données</h2>
        <p>
          Nous conservons vos données personnelles uniquement pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées :
        </p>
        
        <div class="retention-table">
          <div class="retention-row">
            <div class="retention-type">Demandes de devis / Contact</div>
            <div class="retention-duration">3 ans à compter du dernier contact</div>
          </div>
          <div class="retention-row">
            <div class="retention-type">Clients actifs</div>
            <div class="retention-duration">Durée de la relation commerciale + 5 ans</div>
          </div>
          <div class="retention-row">
            <div class="retention-type">Prospects (sans suite)</div>
            <div class="retention-duration">3 ans à compter du dernier contact</div>
          </div>
          <div class="retention-row">
            <div class="retention-type">Données de navigation (cookies)</div>
            <div class="retention-duration">13 mois maximum</div>
          </div>
          <div class="retention-row">
            <div class="retention-type">Documents comptables</div>
            <div class="retention-duration">10 ans (obligation légale)</div>
          </div>
        </div>
        
        <p>
          À l'issue de ces durées, vos données sont supprimées de manière sécurisée ou anonymisées à des fins statistiques.
        </p>
      </article>

      <!-- Article 7 -->
      <article id="article-7" class="privacy-article">
        <div class="article-number">Article 7</div>
        <h2>Vos Droits sur Vos Données Personnelles</h2>
        <p>
          Conformément au RGPD et à la législation marocaine, vous disposez des droits suivants concernant vos données personnelles :
        </p>
        
        <div class="rights-grid">
          <div class="right-card">
            <h4>👁️ Droit d'accès</h4>
            <p>Vous avez le droit d'obtenir une copie de vos données personnelles que nous détenons.</p>
          </div>
          
          <div class="right-card">
            <h4>✏️ Droit de rectification</h4>
            <p>Vous pouvez demander la correction de données inexactes ou incomplètes.</p>
          </div>
          
          <div class="right-card">
            <h4>🗑️ Droit à l'effacement</h4>
            <p>Vous pouvez demander la suppression de vos données dans certaines conditions.</p>
          </div>
          
          <div class="right-card">
            <h4>🚫 Droit d'opposition</h4>
            <p>Vous pouvez vous opposer au traitement de vos données à des fins de marketing direct.</p>
          </div>
          
          <div class="right-card">
            <h4>⏸️ Droit à la limitation</h4>
            <p>Vous pouvez demander la limitation du traitement de vos données.</p>
          </div>
          
          <div class="right-card">
            <h4>📦 Droit à la portabilité</h4>
            <p>Vous pouvez recevoir vos données dans un format structuré et les transmettre à un autre responsable.</p>
          </div>
        </div>
        
        <div class="highlight-box">
          <strong>Comment exercer vos droits ?</strong>
          <br><br>
          Pour exercer l'un de ces droits, contactez-nous :
          <br>• Par email : <strong>Digitalalchemyma&#64;gmail.com</strong>
          <br>• Par téléphone : <strong>+212 690 459 525</strong> (Maroc) ou <strong>+33 1 23 45 67 89</strong> (France)
          <br>• Par courrier : Bd Dammam, Technopark Casablanca , Maroc . Rabat, Maroc
          <br><br>
          Nous vous répondrons dans un délai d'un mois maximum.
        </div>
        
        <p>
          <strong>Droit de réclamation :</strong> Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la Commission Nationale de contrôle de la protection des Données à caractère Personnel (CNDP) au Maroc ou auprès de la CNIL en France.
        </p>
      </article>

      <!-- Article 8 -->
      <article id="article-8" class="privacy-article">
        <div class="article-number">Article 8</div>
        <h2>Cookies et Technologies Similaires</h2>
        <p>
          Notre site utilise des cookies et technologies similaires pour améliorer votre expérience et analyser l'utilisation du site.
        </p>
        
        <h3>8.1 Qu'est-ce qu'un cookie ?</h3>
        <p>
          Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, smartphone, tablette) lors de la visite d'un site web. Il permet au site de se souvenir de vos actions et préférences.
        </p>
        
        <h3>8.2 Types de cookies utilisés</h3>
        <div class="cookie-types">
          <div class="cookie-type">
            <h4>🔧 Cookies essentiels</h4>
            <p>Nécessaires au fonctionnement du site. Ils ne peuvent pas être désactivés.</p>
            <span class="cookie-duration">Durée : Session</span>
          </div>
          
          <div class="cookie-type">
            <h4>📊 Cookies analytiques</h4>
            <p>Nous aident à comprendre comment les visiteurs utilisent le site (Google Analytics).</p>
            <span class="cookie-duration">Durée : 13 mois</span>
          </div>
          
          <div class="cookie-type">
            <h4>⚡ Cookies de performance</h4>
            <p>Améliorent les performances et la vitesse de chargement du site.</p>
            <span class="cookie-duration">Durée : 12 mois</span>
          </div>
          
          <div class="cookie-type">
            <h4>🎯 Cookies marketing</h4>
            <p>Permettent d'afficher des publicités personnalisées (nécessitent votre consentement).</p>
            <span class="cookie-duration">Durée : 13 mois</span>
          </div>
        </div>
        
        <h3>8.3 Gestion des cookies</h3>
        <p>
          Vous pouvez à tout moment gérer vos préférences de cookies via :
        </p>
        <ul>
          <li>Le bandeau de consentement lors de votre première visite</li>
          <li>Les paramètres de votre navigateur</li>
          <li>Notre outil de gestion des cookies (accessible en pied de page)</li>
        </ul>
        <div class="warning-box">
          <strong>⚠️ Attention :</strong> La désactivation de certains cookies peut affecter votre expérience d'utilisation du site et limiter l'accès à certaines fonctionnalités.
        </div>
      </article>

      <!-- Article 9 -->
      <article id="article-9" class="privacy-article">
        <div class="article-number">Article 9</div>
        <h2>Sécurité des Données</h2>
        <p>
          La sécurité de vos données personnelles est une priorité absolue pour Digital Alchemy. Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre :
        </p>
        <ul>
          <li>L'accès non autorisé</li>
          <li>La divulgation accidentelle ou illicite</li>
          <li>La modification, la perte ou la destruction</li>
          <li>Toute autre forme de traitement non autorisé</li>
        </ul>
        
        <h3>Mesures de sécurité mises en place</h3>
        <div class="security-measures">
          <div class="security-item">
            <div class="security-icon">🔐</div>
            <h4>Chiffrement SSL/TLS</h4>
            <p>Toutes les communications sont sécurisées par protocole HTTPS</p>
          </div>
          
          <div class="security-item">
            <div class="security-icon">🔑</div>
            <h4>Accès contrôlé</h4>
            <p>Seules les personnes autorisées ont accès à vos données</p>
          </div>
          
          <div class="security-item">
            <div class="security-icon">💾</div>
            <h4>Sauvegardes régulières</h4>
            <p>Vos données sont sauvegardées de manière sécurisée</p>
          </div>
          
          <div class="security-item">
            <div class="security-icon">🛡️</div>
            <h4>Protection anti-virus</h4>
            <p>Nos systèmes sont protégés contre les menaces</p>
          </div>
        </div>
        
        <p>
          Malgré tous nos efforts, aucune méthode de transmission sur Internet ou de stockage électronique n'est totalement sécurisée. Si vous avez des raisons de croire que vos données ont été compromises, contactez-nous immédiatement.
        </p>
      </article>

      <!-- Article 10 -->
      <article id="article-10" class="privacy-article">
        <div class="article-number">Article 10</div>
        <h2>Partage et Divulgation des Données</h2>
        <p>
          Nous ne vendons, ne louons et ne partageons jamais vos données personnelles à des fins commerciales avec des tiers.
        </p>
        
        <h3>Destinataires de vos données</h3>
        <p>
          Vos données peuvent être partagées uniquement avec :
        </p>
        <ul>
          <li>
            <strong>Notre équipe interne :</strong> Les employés de Digital Alchemy qui ont besoin d'accéder à vos données pour vous fournir nos services
          </li>
          <li>
            <strong>Prestataires de services :</strong> Hébergement web, outils d'email marketing, outils d'analyse (Google Analytics), services de paiement
          </li>
          <li>
            <strong>Autorités compétentes :</strong> En cas d'obligation légale ou de demande judiciaire
          </li>
        </ul>
        
        <div class="highlight-box">
          <strong>🤝 Engagement de nos prestataires :</strong>
          <br>
          Tous nos prestataires sont soigneusement sélectionnés et s'engagent contractuellement à :
          <ul>
            <li>Respecter la confidentialité de vos données</li>
            <li>Utiliser vos données uniquement pour les finalités convenues</li>
            <li>Mettre en place des mesures de sécurité appropriées</li>
            <li>Ne pas transférer vos données à des tiers sans autorisation</li>
          </ul>
        </div>
      </article>

      <!-- Article 11 -->
      <article id="article-11" class="privacy-article">
        <div class="article-number">Article 11</div>
        <h2>Transferts Internationaux de Données</h2>
        <p>
          Dans le cadre de nos activités au Maroc et en France, vos données peuvent être transférées et stockées :
        </p>
        <ul>
          <li>Au Maroc (siège social)</li>
          <li>Dans l'Union Européenne (France)</li>
          <li>Chez certains prestataires situés hors de l'UE</li>
        </ul>
        
        <p>
          Lorsque vos données sont transférées hors de l'Union Européenne, nous nous assurons que :
        </p>
        <ul>
          <li>Le pays destinataire bénéficie d'une décision d'adéquation de la Commission Européenne, OU</li>
          <li>Des garanties appropriées sont mises en place (clauses contractuelles types, certifications, etc.)</li>
        </ul>
      </article>

      <!-- Article 12 -->
      <article id="article-12" class="privacy-article">
        <div class="article-number">Article 12</div>
        <h2>Modifications de la Politique de Confidentialité</h2>
        <p>
          Nous nous réservons le droit de modifier cette Politique de Confidentialité à tout moment pour refléter :
        </p>
        <ul>
          <li>Les évolutions de nos services</li>
          <li>Les changements de réglementation</li>
          <li>Les améliorations de nos pratiques de protection des données</li>
        </ul>
        
        <p>
          En cas de modification substantielle, nous vous en informerons par :
        </p>
        <ul>
          <li>Une notification sur notre site web</li>
          <li>Un email à l'adresse que vous nous avez fournie (si applicable)</li>
        </ul>
        
        <p>
          La version la plus récente de cette politique est toujours disponible sur cette page avec indication de la date de dernière mise à jour.
        </p>
        
        <p>
          Nous vous encourageons à consulter régulièrement cette page pour rester informé de la manière dont nous protégeons vos données.
        </p>
      </article>

      <!-- Contact Article -->
      <article class="privacy-article contact-article">
        <h2>Contactez Notre Délégué à la Protection des Données</h2>
        <p>
          Pour toute question concernant cette Politique de Confidentialité ou pour exercer vos droits :
        </p>
        <div class="contact-info">
          <div class="contact-item">
            <strong>📧 Email :</strong> Contact&#64;digalchemy.com (Objet : "Protection des données")
          </div>
          <div class="contact-item">
            <strong>📞 Téléphone :</strong> +212 690 459 525 (Maroc) | +33 6 66 07 64 55 (France)
          </div>
          <div class="contact-item">
            <strong>📮 Courrier :</strong> Digital Alchemy, Bd Dammam, Technopark Casablanca , Maroc . Rabat, Maroc
          </div>
        </div>
        <div class="response-time">
          <strong>⏱️ Délai de réponse :</strong> Nous nous engageons à répondre à vos demandes dans un délai maximum d'un mois.
        </div>
      </article>

    </div>
  </div>
</section>



<footer class="footer-section">
  <div class="footer-container">
    
    <!-- Main Footer Content -->
    <div class="footer-content">
      
      <!-- Section 1: Company Logo & Description -->
      <div class="footer-company">
        <div class="company-logo">
          <img src="assets/images/logo-white.png" alt="Rhillane Logo" />
        </div>
        
        <p class="company-description">
          Digital Alchemy, votre partenaire de confiance pour la création de sites web . 
          Nous transformons vos idées en succès digital avec des solutions innovantes et performantes.
        </p>
        
        <!-- Social Media -->
        <div class="social-media-section">
          <ul style="display: flex; gap: 16px; list-style: none; padding: 0; margin: 0;">
            
            <!-- Facebook -->
            <li style="margin: 0;">
              <a href="https://www.facebook.com/people/Digital-alchemy/61565618420833" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Facebook page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #1877F2; fill: #1877F2;" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </li>
            
            <!-- Behance -->
            <li style="margin: 0;">
              <a href="https://www.behance.net/digitalalchemy2" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Behance page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #1769FF; fill: #1769FF;" viewBox="0 0 24 24">
                  <path d="M0 4.4804V19.243h7.1554c.6613 0 1.3078-.0832 1.9297-.248.6288-.1654 1.1905-.4203 1.6792-.7661.485-.3431.8784-.7804 1.1677-1.3081.2862-.5258.4294-1.1471.4294-1.8641 0-.8784-.2067-1.6309-.6172-2.2506-.4073-.6172-.9897-1.0907-1.7494-1.4161.6388-.3431 1.1139-.8141 1.4285-1.4143.3146-.6002.4719-1.2755.4719-2.0274 0-.7193-.1327-1.3487-.4-1.8888-.2668-.5402-.6343-1.0033-1.0995-1.3914-.4652-.3881-.9712-.6884-1.5186-.8999C8.8135 4.5932 8.2071 4.4804 7.5446 4.4804H0zM15.3486 6.9795h4.7992v1.2755h-4.7992V6.9795zM3.2695 6.9795h3.8893c.9451 0 1.6612.2262 2.1463.6787.4851.4525.7277 1.0632.7277 1.8321 0 .8374-.2768 1.4676-.8323 1.8888-.5555.4212-1.2925.6323-2.2091.6323H3.2695V6.9795zM15.3486 13.2363h4.7992v1.2755h-4.7992v-1.2755zM3.2695 14.2834h4.3172c.6927 0 1.2944.1327 1.8051.3976.5107.2649.9378.6154 1.2755 1.0519.3377.4365.5849.9378.741 1.5044.1561.5666.2342 1.1543.2342 1.7632 0 .7193-.1014 1.3487-.3043 1.8888-.2029.5401-.5107.9949-.9237 1.3648-.4131.3699-.9378.6507-1.5743.8409-.6365.1902-1.3858.2853-2.2477.2853H3.2695v-7.0969z"/>
                </svg>
              </a>
            </li>
            
            <!-- LinkedIn -->
            <li style="margin: 0;">
              <a href="https://www.linkedin.com/company/digital-alchemy-ma/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our LinkedIn page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #0077B5; fill: #0077B5;" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </li>
            
            <!-- YouTube -->
            <li style="margin: 0;">
              <a href="https://www.youtube.com/@Digital_Alchemy_ma" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our YouTube page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #FF0000; fill: #FF0000;" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </li>
            
            <!-- Instagram -->
            <li style="margin: 0;">
              <a href="https://www.instagram.com/digital_alchemy_ma/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Instagram page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #E1306C; fill: #E1306C;" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </li>
            
          </ul>
        </div>
      </div>
      
      <!-- Section 2: Contact Information -->
      <div class="footer-contact">
        <h3 class="footer-title">CONTACT</h3>
        
        <div class="contact-info">
          <div class="contact-item">
            <span>+212 690 459 525</span>
          </div>
          <div class="contact-item">
            <span>+33 6 66 07 64 55</span>
          </div>
          <div class="contact-item">
            <span>Digitalalchemyma&#64;gmail.com</span>
          </div>
          <div class="contact-item">
            <span>Contact&#64;digalchemy.com</span>
          </div>
        </div>
        
        <div class="office-locations">
          <div class="office-item">
            <h4>NOTRE BUREAU AU MAROC</h4>
            <p>Bd Dammam, Technopark Casablanca , Maroc .</p>
          </div>
        </div>
      </div>
      
      <!-- Section 3: Services Column -->
      <div class="footer-links">
        <h3 class="footer-title">NOS SERVICES</h3>
        <ul class="footer-list">
          <li><a routerLink="/web">Sites Web</a></li>
<li><a routerLink="/appweb">Application Web</a></li>
          <li><a routerLink="/publicite">Publicité en ligne</a></li>
          <li><a routerLink="/gestion">Gestion des réseaux sociaux</a></li>
          <li><a routerLink="/design">Design Graphique</a></li>
          <li><a routerLink="/agence">Agence SEO</a></li>
        </ul>
      </div>
      
      <!-- Section 4: Quick Links Column -->
      <div class="footer-links">
        <h3 class="footer-title">LIENS RAPIDES</h3>
        <ul class="footer-list">
          <li><a routerLink="/">Accueil</a></li>
          <li><a routerLink="/apropos">À propos</a></li>
          <li><a routerLink="/contact">Contact</a></li>
          <li><a routerLink="/cgu">Conditions Générales d'Utilisation</a></li>
          <li><a routerLink="/conf">Politique de Confidentialité</a></li>
        </ul>
      </div>
      
    </div>
    
    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <p class="copyright">
          © {{ currentYear }} Digital Alchemy. Tous droits réservés. | 
          <a routerLink="/cgu">Mentions légales</a> | 
          <a routerLink="/conf">Politique des cookies</a>
        </p>
        <div class="footer-bottom-links">
          <a routerLink="/contact">Support</a>
        </div>
      </div>
    </div>
    
  </div>
</footer>